export default "__VITE_ASSET__kJ_aAkPp__";